import { useFormikContext } from "formik";
import { isEmpty } from "lodash";

const FormError = () => {
  const { errors, touched } = useFormikContext();
  return (
    <div className="error py-2">{!isEmpty(errors) && !isEmpty(touched) && "There are errors in the form. Please check your entries and correct them."}</div>
  )
}

export default FormError;